/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserUpdateContextCto } from '../../models/user-update-context-cto';

export interface GetCompanyUsers$Plain$Params {
  companyId: string;
}

export function getCompanyUsers$Plain(http: HttpClient, rootUrl: string, params: GetCompanyUsers$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserUpdateContextCto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyUsers$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserUpdateContextCto>>;
    })
  );
}

getCompanyUsers$Plain.PATH = '/user/all/{companyId}';
